import { Stack, Typography, useTheme } from "@mui/material";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router";
import { Model_QuickSearchGet, Shared_QuickSearchKinds } from "src/backend/openapi/v1";
import { DekoxIcon } from "src/components/deko-x-icons";
import { ROUTES_URL } from "src/utils/constants";

type Props = {
  data: Model_QuickSearchGet;
  handleClose: () => void;
};

export const GlobalSearchRow = (props: Props) => {
  const { data, handleClose } = props;

  const navigate = useNavigate();
  const theme = useTheme();

  const handleOnClick = useCallback(() => {
    switch (data.quickSearchKind) {
      case Shared_QuickSearchKinds.Product:
        navigate(ROUTES_URL.PRODUCT_DETAILS.build(data.entityId));
        break;
    }
    handleClose();
  }, [data]);

  const icon = useMemo(() => {
    switch (data.quickSearchKind) {
      case Shared_QuickSearchKinds.Product:
        return <DekoxIcon icon="category" fontSize="small" color="action" />;
      // case Shared_QuickSearchKinds.Customer:
      //   return <DekoxIcon icon="person" fontSize="small" color="action" />;
      // case Shared_QuickSearchKinds.Project:
      //   return <DekoxIcon icon="handyman" fontSize="small" color="action" />;
    }
    return <></>;
  }, [data]);

  return (
    <Stack
      direction="row"
      gap={1}
      p={1}
      px={3}
      onClick={handleOnClick}
      sx={{
        alignItems: "center",
        cursor: "pointer",
        "&:hover": {
          background: theme.palette.customColors.lightGrey
        }
      }}
    >
      {icon}
      <Typography variant="body1">
        {data.entityNumber} - {data.name}
      </Typography>
    </Stack>
  );
};
